<script>
import { comma } from "../filters/sum";

export default {
  props: {
    title: {
      type: String,
      required: true,
    },

    text: {
      type: [String, Number],
      required: false,
    },

    // Amount rows (Kontrakt summasi, To'langan summasi, Qoldiq): show 16335000 as 16,335,000.
    money: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    // A numeric 0 is a real value: "To'langan summasi: 0" after a full refund,
    // "Qoldiq: 0" on a fully paid contract. Only a missing value
    // (null / undefined / empty string) leaves the row blank.
    hasText() {
      return typeof this.text === "number" ? !Number.isNaN(this.text) : !!this.text;
    },

    shownText() {
      return this.money && this.hasText ? comma(this.text) : this.text;
    },
  },
};
</script>

<template>
  <div>
    <div style="min-height: 24px" :class="hasText ? '-title' : '-text'">
      {{ title }}
    </div>
    <div v-if="hasText" class="-text" v-text="shownText" />
    <div v-else>
      <slot />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.-title {
  font-size: 14px;
}

.-text {
  font-weight: 500;
}
@media (max-width: 600px) {
  .-text { overflow-wrap: anywhere; }
}
</style>
